import { amplitudeLib } from 'freedom-shared';

import { getMainPageVariant } from './main-page';

/**
 * Shape of an offer-level click event payload, shared between the teaser
 * click on the main page and individual list items inside the bottom sheet.
 */
type RecommendedOfferClickProps = {
  search_query: string;
  offer_hash: string;
  origin_city_code: string;
  destination_city_code: string;
  price?: string;
  currency?: string;
};

/**
 * @description Track exposure of the recommended offers block on the main
 * page. Provides the denominator for click-through rates of the
 * `avfree_recommended_offers` A/B experiment.
 * @trigger Once per page mount, when the block becomes visible
 * (treatment users with at least one offer in the response).
 * @location Main page, "Подобрано для вас" block.
 */
export const recommendedOffersShown = (params: { offers_count: number }) => {
  amplitudeLib.logEvent('avfree_recommended_offers_shown', {
    offers_count: params.offers_count,
    main_page_variant: getMainPageVariant(),
  });
};

/**
 * @description Tap on the block header that opens the full list bottom
 * sheet. Distinguishes "list intent" from "single offer intent".
 * @trigger Click on the "Подобрано для вас / Все" trigger row.
 * @location Main page, "Подобрано для вас" block.
 */
export const recommendedOffersTriggerClick = (params: {
  offers_count: number;
}) => {
  amplitudeLib.logEvent('avfree_recommended_offers_trigger_click', {
    offers_count: params.offers_count,
    main_page_variant: getMainPageVariant(),
  });
};

/**
 * @description Tap on the teaser offer card surfaced directly under the
 * trigger row. Treated as an offer click — navigates straight to SERP.
 * @trigger Click on the teaser offer card.
 * @location Main page, "Подобрано для вас" block.
 */
export const recommendedOffersTeaserClick = (
  params: RecommendedOfferClickProps,
) => {
  amplitudeLib.logEvent('avfree_recommended_offers_teaser_click', {
    ...params,
    main_page_variant: getMainPageVariant(),
  });
};

/**
 * @description Tap on an offer inside the full-list bottom sheet.
 * @trigger Click on a list item.
 * @location Recommended offers bottom sheet.
 */
export const recommendedOffersListItemClick = (
  params: RecommendedOfferClickProps & { index: number },
) => {
  amplitudeLib.logEvent('avfree_recommended_offers_list_item_click', {
    ...params,
    main_page_variant: getMainPageVariant(),
  });
};
